// exhibit-highlight-modal.js                                   ~/js/swipers
///////////////////////////////////////////////////////////////////////////

import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

// Exhibit Content Page - Exhibit Highlights Modal Swiper
export const ExhibitHighlightsModalSwiper = new Swiper(
  '.single-exhibit-highlights-modal-swiper',
  {
    modules: [Navigation],
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  },
);
